// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  GetTimeRecordTimeSeriesParams,
  getTimeRecordTimeSeries,
} from '@/costs/api/get-time-record-time-series';
import { TimeRecordTimeSeries } from '@/costs/api/types';
import { type UseQueryResult, useQuery } from '@tanstack/react-query';

/**
 * Hook for fetching time record time series data
 */
export const useTimeRecordTimeSeries = (
  params: GetTimeRecordTimeSeriesParams = {},
  options?: {
    enabled?: boolean;
  }
): UseQueryResult<TimeRecordTimeSeries> => {
  return useQuery({
    queryKey: ['time-records', 'time-series', params],
    queryFn: () => getTimeRecordTimeSeries(params),
    enabled: options?.enabled,
  });
};
